<template>
  <div class="fontawesome-icons">
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'left')"
      class="fa fa-chevron-circle-left"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="left"
    />
    <span
      :class="[{'fa fa-pause-circle': isPlay}, {'fa fa-play-circle': !isPlay}]"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="playOrPause"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'right')"
      class="fa fa-chevron-circle-right"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="right"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'up')"
      class="fa fa-chevron-circle-up"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="up"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'down')"
      class="fa fa-chevron-circle-down"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="down"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'zoomin')"
      class="fa fa-plus-circle"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="zoomIn"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'zoomout')"
      class="fa fa-minus-circle"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="zoomOut"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'fullscreen')"
      class="fa fa-arrows-alt"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="fullScreen"
    />
    <span
      v-if="enableSpinButton(spinSelectedButtons, 'info')"
      class="fa fa-info-circle"
      :style="{'color': spinControlIconsColor, 'font-size': size + 'px'}"
      @click="info"
    />
    <SpinInfo
      v-if="infoStatus"
      :text="infoText"
    />
  </div>
</template>

<script>
import { spinButtonControlMixin } from '@/mixins/spinButtonControl.mixin'
import SpinInfo from '@/widgets/common/SpinInfo'
import { mapGetters } from 'vuex'

export default {
  name: 'SpinFontawesomeButtons',
  components: {
    SpinInfo
  },
  mixins: [spinButtonControlMixin],
  computed: {
    ...mapGetters({
      spinControlIconsColor: 'spinControl/spinControlIconsColor',
      size: 'spinControl/size'
    })
  }
}
</script>

<style lang="scss" scoped>
@import url('https://use.fontawesome.com/07d4a8a4ad.css');
.fontawesome-icons {
  width: 100%;
  min-height: 80px;
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-evenly;
  span {
    display: flex;
    width: 30px;
    height: 30px;
    justify-content: center;
    align-items: center;
    font-family: 'FontAwesome';
    cursor: pointer;
    font-size: 30px;
  }
}
</style>
